<template>
  <div v-if="Object.keys(data).length > 0" class="app-markdown-tag-wrapper">
    <template v-for="(value, key) in data" :key="key">
      <div v-if="value?.length" class="app-markdown-tags">
        <span v-if="fixTagsTransify(key)" class="app-markdown-tags-title">{{ fixTagsTransify(key) }}: </span>
        <template v-for="(item, index) in value" :key="index">
          <CommonMarkdownTag v-if="item.name" :link="item.link" :hover-text="item.hover" :class-name="key">
            {{ item.name }}
          </CommonMarkdownTag>
        </template>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { DocumentTags } from '~/server/types'

defineProps({
  data: {
    type: Object as PropType<DocumentTags>,
    default: () => {}
  }
})
const { formatTransify } = useStore()
const fixTagsTransify = (key: string) => {
  key = key.toLowerCase()
  if (key.includes('addable')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_ADDABLE')
  }
  if (key.includes('combine')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_COMBINE')
  }
  if (key.includes('exclusive')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_EXCLUSIVE')
  }
  if (key.includes('rely')) {
    return formatTransify('UGC_OFFICIAL_WEBSITE_RELY')
  }
  return ''
}
</script>
<style lang="scss" scoped>
/* --- markdown tags --- */
.app-markdown-tag-wrapper {
  margin-bottom: 10px;
}
.app-markdown-tags {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .app-markdown-tags-title {
    font-size: 20px;
    margin-right: 16px;
    color: #c8ccd3;
  }
  &:deep(.app-markdown-tag) {
    margin: 0 10px 10px 0;
  }
}
</style>
